
import { createTheme, Theme } from '@mui/material/styles';

import { getComponentOverrides } from './components';
import { darkPalette, lightPalette } from './palette';
import { typography } from './typography';

export function createAgencyTheme(mode: 'light' | 'dark'): Theme {
  const palette = mode === 'dark' ? darkPalette : lightPalette;

  const baseTheme = createTheme({
    palette,
    typography,
    shape: {
      borderRadius: 8,
    },
  });

  return createTheme(baseTheme, {
    components: getComponentOverrides(baseTheme),
  });
}
